module.exports = __webpack_public_path__ + "static/img/ss04.fd094ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/rickle/ss04.png
// module id = aEc0
// module chunks = 0